/** A count as the menu shows it: past 99 the exact number stops mattering. */
export function countText(count: number): string {
  return count > 99 ? "99+" : String(count);
}

/**
 * A link's name with its count, for the icon rail: there the name is the
 * link's aria-label, which hides what is inside it, so the count is said here.
 */
export function countName(label: string, count: number): string {
  return count > 0 ? `${label}, ${countText(count)} new` : label;
}

/**
 * A count beside a menu link, or nothing at zero. On the icon rail it is a
 * dot in the corner, since there is no room for a number beside a 40px icon;
 * the link's own name carries the count there.
 */
export function NavCount({ count, rail }: { count: number; rail: boolean }) {
  if (count <= 0) return null;
  return rail ? (
    <span
      aria-hidden
      className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-sidebar-accent"
    />
  ) : (
    <span
      className={
        "rounded-full bg-sidebar-accent px-1.5 text-[11px] font-semibold leading-5 " +
        "text-sidebar-bg"
      }
    >
      {countText(count)}
      <span className="sr-only"> new</span>
    </span>
  );
}
